/**
 * @fileoverview GET handler for the "/engagement/ab_testing_schedule_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAbTestingScheduleData } from "./constants";
import type { EngagementAbTestingScheduleDataResult } from "./types";

export const getEngagementAbTestingScheduleData = reactQueryFetcherAdapter(
  engagementAbTestingScheduleData,
  (
    signal: AbortSignal,
    appGroupId: string,
    startTimeUnix: number
  ): Promise<EngagementAbTestingScheduleDataResult> => {
    return fetch(
      "/engagement/ab_testing_schedule_data",
      "GET",
      { app_group_id: appGroupId, start_time_unix: startTimeUnix },
      { signal }
    );
  }
);
